import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './features/languageDecider'

export default configureStore({
  reducer: {
    language: counterReducer,
  },
})